<div class="flex flex-col gap-4">

  <!-- General Informations -->
  <div class="flex justify-between">
    <elcia-label label="{{'app.informations' | translate}}"/>
    <elcia-toggle-switch [control]="form().controls.isActive"
                         [label]="'customer.is-active' | translate"/>
  </div>
  <div class="grid grid-cols-3 gap-4">
    <!-- FirstName -->
    <elcia-text-input [control]="form().controls.firstname" [label]="'user.first-name' | translate"/>
    <!-- LastName -->
    <elcia-text-input [control]="form().controls.lastname" [label]="'user.last-name' | translate"/>
    <!-- Phone -->
    <elcia-text-input [control]="form().controls.phone" [label]="'customer.phone' | translate"/>
    <!-- Email -->
    <elcia-text-input [control]="form().controls.email" [label]="'user.email' | translate"/>
    <!-- Company -->
    <elcia-party-dropdown [control]="form().controls.companyId" [label]="'entity.company' | translate"
                          [partyTypes]="companyPartyTypes"/>
    <!-- Legal entity in charge of invoicing this contact -->
    <elcia-legal-entity-dropdown [control]="form().controls.legalEntityAssignedId"/>
    <!-- Locale -->
    <elcia-local-dropdown [control]="form().controls.localeIsoCode"/>
  </div>

  <!-- Addresses -->
  <div class="flex flex-col gap-4">
    <!-- Is Same Billing Address -->
    <div class="flex justify-between">
      <elcia-label [label]="'address.address' | translate"/>
      <elcia-toggle-switch [control]="form().controls.isSameAddressForBilling"
                           [label]="'address.same-as-billing-address' | translate"/>
    </div>
    <!-- Address Form -->
    <elcia-address-form [control]="form().controls.addressForm"/>
    <!-- Billing Address Form -->
    @if (!form().controls.isSameAddressForBilling.value) {
      <div [animate.enter]="'slide-in-top'" class=" flex flex-col gap-4">
        <elcia-label [label]="'address.billing-address' | translate"/>
        <elcia-address-form [control]="form().controls.billingAddressForm"/>
      </div>
    }
  </div>

  <!-- Note -->
  <div class="flex flex-col gap-4">
    <elcia-label [label]="'customer.notes' | translate"/>
    <elcia-editor [control]="form().controls.note" [styles]="{ height: '200px' }"/>
  </div>

</div>
